import { render, staticRenderFns } from "./UserAuthIndex.vue?vue&type=template&id=7563de3e&scoped=true"
import script from "./UserAuthIndex.vue?vue&type=script&lang=js"
export * from "./UserAuthIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7563de3e",
  null
  
)

export default component.exports